module.exports = __webpack_public_path__ + "static/media/labtest.d476b3b5.png";